import Api from '../api';

const { axios: api } = Api;
const PREFIX = 'analytics';

export const createAnalyticsEvent = async (payload) => {
	const { data } = await api.post(`/${PREFIX}/events`, payload);
	return data;
};
